// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"99":"94999ca1","201":"318f2ef7","558":"fdfe1e61","611":"91059502","756":"3148e07b"}[chunkId] + ".chunk.css";
};